import React from "react";
import PropTypes from "prop-types";
import ErrorMessage from "../error-message/ErrorMessage";

const SearchInput = (props) => {
    const { name, handleChange, handleBlur, label, isRequired, placeholder, fieldRegister, errorMessage, disabled, maxLength } = props;

    return (
        <React.Fragment>
            {label && <label className={isRequired ? "required" : ""}>{label}</label>}
            <input
                data-testid={name}
                name={name}
                type="search"
                className={errorMessage ? "input input--error" : "input"}
                placeholder={placeholder || ''}
                onChange={handleChange}
                onBlur={handleBlur}
                disabled={disabled}
                maxLength={maxLength}
                {...fieldRegister}
            />
            {errorMessage && <ErrorMessage error={errorMessage} />}
        </React.Fragment>
    );
};

SearchInput.propTypes = {
    name: PropTypes.string,
    label: PropTypes.string,
    isRequired: PropTypes.bool,
    placeholder: PropTypes.string,
    errorMessage: PropTypes.string,
    handleChange: PropTypes.func,
    handleBlur: PropTypes.func,
    disabled: PropTypes.bool,
    maxLength: PropTypes.number
}

export default SearchInput;